"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var BigIntegerValidator_1 = require("../../../core/model/data-dictionary/validators/BigIntegerValidator");

var BigNumberRangeValidator_1 = require("../../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");

var SimpleConstraint_1 = require("./SimpleConstraint");
/**
 * The maximum frequency of the price changes.
 *
 * @author RV
 */


var RepricingFrequency =
/*#__PURE__*/
function (_SimpleConstraint_1$S) {
  _inherits(RepricingFrequency, _SimpleConstraint_1$S);

  /**
   * @inheritDoc
   */
  function RepricingFrequency(value) {
    var _this;

    _classCallCheck(this, RepricingFrequency);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RepricingFrequency).call(this, value));
    _this.value = value;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RepricingFrequency, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.RepricingFrequency;
    }
  }]);

  return RepricingFrequency;
}(SimpleConstraint_1.SimpleConstraint);

exports.RepricingFrequency = RepricingFrequency;
RepricingFrequency.MIN_VALUE = 0;
RepricingFrequency.MAX_VALUE = 100; // tslint:disable-next-line:member-ordering

RepricingFrequency.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimpleConstraint_1.SimpleConstraint.name);
  return {
    value: builder.bigNum('value', new BigNumberRangeValidator_1.BigNumberRangeValidator(RepricingFrequency.MIN_VALUE, RepricingFrequency.MAX_VALUE), new BigIntegerValidator_1.BigIntegerValidator())
  };
}();